module.exports = __webpack_public_path__ + "img/soccer-ball.fb70f8e2.png";